import { useDispatch } from "react-redux";

import { Column, Columns, Heading, Modal, Stack } from "@seneca/senekit";

import { useRedirectToAppropriateHomepage } from "seneca-common/utils/hooks/routing";
import { logSignUpEventByAccountType } from "seneca-common/utils/senecaAnalytics";

import AccountTypeButton, {
  accountTypeBtn
} from "features/sign-up/sign-up-form/components/SignUpFormAccountType/AccountTypeButton";
import { setAccountTypeToSchoolTeacher, userAccountType } from "features/user";
import {
  setAccountTypeToSchoolParent,
  setAccountTypeToSchoolStudent
} from "features/user/actions/userInfo";

import LogoPageWrapper from "../../components/LogoPageWrapper";

export default function CompleteAccountTypeModal() {
  const modalProps = {
    partOfJourney: false,
    fullscreenOnMobile: true
  };
  useRedirectToAppropriateHomepage();
  const dispatch = useDispatch();

  const handleStudentClick = () => {
    dispatch(setAccountTypeToSchoolStudent());
    logSignUpEventByAccountType(userAccountType.schoolstudent);
  };

  const handleTeacherClick = () => {
    dispatch(setAccountTypeToSchoolTeacher());
    logSignUpEventByAccountType(userAccountType.schoolteacher);
  };

  const handleParentClick = () => {
    dispatch(setAccountTypeToSchoolParent());
    logSignUpEventByAccountType(userAccountType.schoolparent);
  };

  return (
    <LogoPageWrapper>
      <Modal {...modalProps}>
        <Stack space="xxlarge">
          <Heading level="4" align="center">
            Select your Seneca account type:
          </Heading>
          <Columns collapseBelow="tablet" space="large">
            <Column>
              <AccountTypeButton
                accountType={accountTypeBtn.student.displayName as any}
                selected={false}
                onClick={handleStudentClick}
              />
            </Column>
            <Column>
              <AccountTypeButton
                accountType={accountTypeBtn.teacher.displayName as any}
                selected={false}
                onClick={handleTeacherClick}
              />
            </Column>
            <Column>
              <AccountTypeButton
                accountType={accountTypeBtn.parent.displayName as any}
                selected={false}
                onClick={handleParentClick}
              />
            </Column>
          </Columns>
        </Stack>
      </Modal>
    </LogoPageWrapper>
  );
}
